<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span
                    @click="signOut" style="color:#fff">{{ $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('guest.out.title') }}</div>
                <div class="mainBody">
                    <p style="line-height:0.45rem;"><span
                            class="red">{{ $t('guest.out.tips1.title') }}:</span><br>{{ $t('guest.out.tips1.one') }}
                    </p>
                    <p style="line-height:0.45rem;">{{ $t('guest.out.tips1.two') }}</p>
                    <p style="line-height:0.45rem;">
                        {{ $t('guest.out.tips1.three')
                        }}<br>{{ $t('guest.out.tips1.three11') }}<br>{{ $t('guest.out.tips1.three1') }}<br>{{ $t('guest.out.tips1.three2') }}<br>{{ $t('guest.out.tips1.three3') }}
                    </p>
                    <p style="line-height:0.45rem;">{{ $t('guest.out.tips1.four') }} （{{ $t('guest.out.tips1.four1')
                        }}：
                        <a href="tel:13882292230" style="color:#fff">138 8229 2230</a>）
                    </p>

                    <!-- 发票须知 -->
                    <!-- <p style="line-height:0.45rem;"><span
                            class="red">{{ $t('guest.out.tips2.title') }}:</span><br>{{ $t('guest.out.tips2.tips1') }}:
                        <br>{{ $t('guest.out.tips2.tips2') }}
                        <br>{{ $t('guest.out.tips2.tips3') }}
                    </p>
                    <p style="line-height:0.45rem;"><span
                            class="red">{{ $t('guest.out.tips3.title') }}:</span><br>{{ $t('guest.out.tips3.one') }}
                    </p> -->
                </div>
            </div>
        </div>
        <div class="back" @click="path('guest')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
    </div>
</template>
<script>
import menus from "../../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),

        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/guest/out']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        }
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/guest/out.vue